<template>
    <section class="stf-card" :class="{
        'stf-card--success': success && !error,
        'stf-card--error': error
    }">
        <div v-if="$slots.title" class="stf-card-title">
            <slot name="title"></slot>
        </div>
        <StfDivider v-if="$slots.title && !hideDivider" :stick-bottom="stickBottomDivider"></StfDivider>
        <div class="stf-card-content">
            <slot name="content"></slot>
        </div>
    </section>
</template>

<script setup lang="ts">
import StfDivider from '@/ui/divider/StfDivider.vue';

interface Props {
    hideDivider?: boolean;
    stickBottomDivider?: boolean;
    success?: boolean;
    error?: boolean;
}
withDefaults(defineProps<Props>(), {
    hideDivider: false,
    stickBottomDivider: false,
    success: false,
    error: false
});
</script>

<style scoped lang="scss">
@use "bulma/sass/utilities/mixins";
@use '@/assets/sass/_variables' as vars;

.stf-card {
  border-radius: vars.$border-radius-desktop;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  border-color: rgba(229, 229, 229, 1);
  border-style: solid;
  border-width: 2px;
  width: 100%;
  padding: 20px 36px;
  box-sizing: border-box;

  &--success {
    border-color: vars.$color-success;
  }

  &--error {
    border-color: vars.$color-error;
  }

  @include mixins.mobile {
    border-radius: vars.$border-radius-mobile;
    padding: 15px 20px;
  }
}
</style>
